import Document from '@tiptap/extension-document';

export const TaskListDocument = Document.extend({
    // An optional, single, unstyled title line followed by the task list.
    content: 'taskListTitle? taskList',
});
